var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8668 29.8319V48.3512H43.2993V30.6371C43.2993 29.3109 42.5414 28.5057 40.1732 28.5057C38.6102 28.5057 37.3314 29.3583 36.0526 30.4476V48.3512H26.3903V30.6371C26.3903 29.3109 25.6799 28.5057 23.3117 28.5057C21.8434 28.5057 20.5172 29.2635 19.1437 30.4003V48.3512H9.57617V24.1008H19.1437V28.553C21.1803 25.8533 24.0695 23.6272 28.5691 23.6272C32.595 23.6272 35.2948 25.3323 35.9105 29.1214C37.8051 26.2796 40.9311 23.6272 45.3832 23.6272C50.167 23.6272 52.8668 25.7586 52.8668 29.8319Z",
    fill: "#252D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.047 38.1849L56.9639 43.2681L62.047 48.3512L67.1302 43.2681L62.047 38.1849Z",
    fill: "#FF576D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_1145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.5543,
    height: 24.724,
    fill: "white",
    transform: "translate(9.57715 23.6272)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/shortLogo.6fb4cce631ee4af3daffbbb799525122.svg";
export { ForwardRef as ReactComponent };